class Item {

	constructor(options) {
		this.db = options.db;
		this.storeName = 'items'
	}

	add(item) {
		return new Promise((resolve) => {
			var
				tx = this.db.transaction(this.storeName, 'readwrite'),
				store = tx.objectStore(this.storeName),
				name = item.replace(/[\>\<]+/g, '').replace(/\s{2,}/g, '').trim(),
				response
			;

			if (!name) {
				return;
			}

			response = store.put({name});
			response.onsuccess = () => {
				resolve(name);
			};
		});
	}

	delete(item) {
		return new Promise((resolve) => {
			var
				tx = this.db.transaction(this.storeName, 'readwrite'),
				store = tx.objectStore(this.storeName),
				name = item,
				response
			;

			if (!name) {
				return
			}

			response = store.delete(name);
			response.onsuccess = () => {
				resolve();
			};
		});
	}

	/**
	 * Returns all items
	 * @return {Promise}
	 */
	getAll() {
		return new Promise((resolve) => {
			var
				tx = this.db.transaction(this.storeName, 'readonly'),
				store = tx.objectStore(this.storeName),
				items = [],
				response
			;

			if ('getAll' in store) {
				response = store.index('name').getAll();
				response.onsuccess = () => {
					resolve(response.result);
				}
			} else {
				// Fallback
				store.openCursor().onsuccess = (event) => {
					var cursor = event.target.result;
					if (cursor) {
						items.push(cursor.value);
						cursor.continue();
					} else {
						resolve(items);
					}
				}
			}
		});
	}

	/**
	 * Clear item storage
	 */
	clear() {
		var
			tx = this.db.transaction(this.storeName, 'readwrite'),
			store = tx.objectStore(this.storeName)
		;

		store.clear();
	}

}

export default Item;



// WEBPACK FOOTER //
// ./src/js/modules/item.js